import React, { memo } from 'react';
import { Button, Icon, Tag } from '@ann/web-components';
import {
  CardContent,
  CardLeft,
  CardRight,
  ContactName,
  Container,
  ContentBlock,
  InfoGroup,
  InfoRow,
  InfoText,
  MockAvatar,
  Separator,
} from './LocationPreviewCard.styled';

const LocationPreviewCard = () => {
  return (
    <Container>
      <CardContent>
        <CardLeft>
          <MockAvatar>MA</MockAvatar>
          <ContentBlock>
            <ContactName>Mike Abbott</ContactName>
            <InfoRow>
              <InfoGroup>
                <Icon name="person" size="small" color="neutral" />
                <InfoText>Employee</InfoText>
              </InfoGroup>
              <Separator>·</Separator>
              <InfoGroup>
                <Icon name="work" size="small" color="neutral" />
                <InfoText>Acme Corp</InfoText>
              </InfoGroup>
              <Separator>·</Separator>
              <InfoText>David Kim</InfoText>
              <Separator>·</Separator>
              <Tag text="Appointment Today" color="informative" size="small" />
            </InfoRow>
          </ContentBlock>
        </CardLeft>
        <CardRight>
          <Button
            icon="aiChat"
            label=""
            size="small"
            type="gradient"
          />
          <Icon name="chevronRight" size="small" color="neutral" />
        </CardRight>
      </CardContent>
    </Container>
  );
};

export default memo(LocationPreviewCard);
